/**
 * Updates [data-industrial-placeholder-px] with live width × height (rounded px) for image placeholders.
 */
(function () {
  var bound = typeof WeakSet !== 'undefined' ? new WeakSet() : new Set();

  function bind(el) {
    if (!el) return;
    var root = el.closest('.industrial-img-placeholder');
    if (!root) return;
    if (bound.has(el)) return;
    bound.add(el);

    function update() {
      var r = root.getBoundingClientRect();
      var w = Math.round(r.width);
      var h = Math.round(r.height);
      el.textContent = w + ' × ' + h + ' px';
    }

    update();
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(update);
      ro.observe(root);
    } else {
      window.addEventListener('resize', update);
    }
  }

  function init() {
    document.querySelectorAll('[data-industrial-placeholder-px]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/**
 * Industrial FAQ accordion: [data-industrial-faq]
 */
(function () {
  function bindSection(root) {
    if (!root || root._industrialFaqBound) return;
    root._industrialFaqBound = true;

    root.querySelectorAll('[data-industrial-faq-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-industrial-faq-item]');
        if (!item) return;
        var open = item.classList.contains('is-open');
        root.querySelectorAll('[data-industrial-faq-item].is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var b = el.querySelector('[data-industrial-faq-trigger]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-industrial-faq]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', initFaq);
})();
